import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Kbd } from '#app/components/typography/kbd'
import { P } from '#app/components/typography/p'
import { Description, Features, Source, Styling, Usage, type componentProps } from '../sections/sections'
import { readSource } from '../sections/sections.server'

export const handle = {
	breadcrumb: 'Kbd',
}

const component: componentProps = {
	name: 'Kbd',
	shortName: 'Kbd',
	fileName: 'kbd',
	category: 'typography',
	description: ['Keyboard component.'],
	features: ['Drop-in replacement for the native <kbd> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<P>
	Press <Kbd>Command + Tab</Kbd> to switch between open apps on macOS.
</P>`,
	styling: `.kbd {
	@apply border-spacing-fluid-1 border-muted-200 bg-muted-50 pb-fluid-3 pt-fluid-4 px-fluid-4 text-fluid-xs text-muted-900 rounded-lg border align-baseline font-mono shadow-sm;
}`,
}

export const loader = async () => json({ source: await readSource({ category: component.category, fileName: component.fileName }) })

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<P>
				Press <Kbd>Command + Tab</Kbd> to switch between open apps on macOS.
			</P>
			<Features features={features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
